import { getIn } from '../../utils/getIn';
export const findFirstNumberPropertyWithValue = phoneNumberProperties => {
  if (!phoneNumberProperties) return undefined;
  return phoneNumberProperties.find(propertyDefinition => {
    const propertyValue = getIn(['value'], propertyDefinition);
    return Boolean(propertyValue);
  });
};
export const findNumberPropertyNameWithValue = (phoneNumberProperties, numberPropertyName) => {
  if (!phoneNumberProperties) return undefined;
  if (!numberPropertyName) {
    return findFirstNumberPropertyWithValue(phoneNumberProperties);
  }
  return phoneNumberProperties.find(propertyDefinition => {
    const propertyValue = getIn(['value'], propertyDefinition);
    const propertyName = getIn(['propertyName'], propertyDefinition);
    return propertyValue && propertyName === numberPropertyName;
  });
};